<template>
  <div v-if="digshow" class="t_dig">
    <div v-if="isDetails">
      <div style="background-color: white; margin-bottom: 15px; position: relative">
        <div v-preventReClick style="
            position: absolute;
            right: 30px;
            top: 30px;
            font-size: 30px;
            color: #606266;
            cursor: pointer;
            z-index: 99
          " @click="back">
          <i class="el-icon-circle-close" />
        </div>
        <div class="t_rk">
          <div class="title">单位信息</div>
          <el-form label-suffix="：" label-width="150px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="单位名称" required label-width="110px">
                  <el-input v-model="row.dwmc" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一社会信用代码" required>
                  <el-input v-model="row.shtyxydm" disabled></el-input></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位联系人" required label-width="110px">
                  <el-input v-model="row.lxrXm" disabled></el-input></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人手机号码" required>
                  <el-input v-model="row.lxrSjh" disabled></el-input></el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div style="background-color: white; margin-top: 15px">
        <div class="t_rk">
          <div class="title">追溯码信息</div>
          <el-form label-suffix="：">
            <el-row>
              <el-col :span="8">
                <el-form-item label="申请批号">{{ row.sqph }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="申请时间">{{ row.sqsj }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="当前状态">{{ row.ztLabel }}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin-bottom: 10px;">
            <el-button type="primary" @click="handleBatchDownload"
              :disabled="selectedRows.length === 0" v-if="row.zt === '21'">批量下载追溯码</el-button>
          </div>
          <el-table :data="row.hxpList" @selection-change="handleSelectionChange"
            :header-cell-style="{ background: '#F2F2F2' }" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="化学品分类" prop="hxplbMc" width="300px">
            </el-table-column>
            <el-table-column label="化学品名称" prop="hxpMc"></el-table-column>
            <el-table-column label="包装层级" prop="bzcjMc"></el-table-column>
            <el-table-column label="RFID厂家" prop="bqcsMc"></el-table-column>
            <el-table-column label="申请数量" prop="sqsl"></el-table-column>
            <el-table-column label="操作" width="120" v-if="row.zt === '21'">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleSingleDownload(scope.row)">下载追溯码</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="background-color: white; margin: 15px 0">
        <div class="bottom_container t_rk">
          <div class="bottom_title" style="padding: 0;">
            <div class="title">
              申请审批
            </div>
            <div class="main_lc">
              <el-timeline>
                <el-timeline-item v-if="dataobj[0]" icon="el-icon-time" size="large">
                  <div style="margin-top: 2px">
                    <span style="font-weight: bold">申请时间：</span><span>{{ dataobj[0].clsj }}</span>
                  </div>
                </el-timeline-item>
                <el-timeline-item v-for="(item, index) in dataobj" :key="index" :icon="item.icon" :type="item.type"
                  :size="item.size">
                  <div style="display: flex; align-items: center; flex-wrap: wrap">
                    <div style="margin-right: 20px">
                      <span style="font-weight: bold">审批单位：</span>{{ item.dqbmLabel }}
                    </div>
                    <div v-if="item.sftyLabel != '待审批'" style="margin-right: 20px">
                      <span style="font-weight: bold">{{ item.jsLabel }}人：</span>{{ item.sjsprLabel }}
                    </div>
                    <div style="margin-right: 20px">
                      <span style="font-weight: bold">审批结果：</span><span :style="'color: ' + item.color">{{
                        item.sftyLabel
                        }}</span>
                    </div>
                    <div v-if="item.sftyLabel != '待审批'" style="margin-right: 20px">
                      <span style="font-weight: bold">审批时间：</span>{{ item.spsj }}
                    </div>
                  </div>
                  <div v-if="item.sftyLabel != '待审批'" style="margin-top: 2px">
                    <span style="font-weight: bold">审批意见：</span><span>{{ item.spyj }}</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="background-color: white; margin-bottom: 15px; position: relative">
        <div v-preventReClick style="
            position: absolute;
            right: 30px;
            top: 30px;
            font-size: 30px;
            color: #606266;
            cursor: pointer;
            z-index: 99
          " @click="back">
          <i class="el-icon-circle-close" />
        </div>
        <div class="t_xkz">
          <div class="title">单位信息</div>
          <el-form :model="addForm" :rules="rules" ref="addForm" label-width="150px" label-suffix="：">
            <el-row>
              <el-col :span="12">
                <el-form-item label="单位名称" prop="dwmc" label-width="110px">
                  <el-input v-model="addForm.dwmc" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一社会信用代码" prop="shtyxydm">
                  <el-input v-model="addForm.shtyxydm" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="单位联系人" prop="lxrXm" label-width="110px">
                  <el-input v-model="addForm.lxrXm" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系人手机号码" prop="lxrSjh">
                  <el-input v-model="addForm.lxrSjh" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div style="background-color: white;">
        <div class="t_rk">
          <div class="title">追溯码信息</div>
          <el-table :data="addForm.hxpList" :header-cell-style="{ background: '#F2F2F2' }" style="width: 100%">
            <el-table-column label="化学品名称" width="350px">
              <template slot-scope="scope">
                <el-cascader size="mini" style="width: 100%" v-model="addForm.hxpList[scope.$index].hxpBmList"
                  placeholder="请选择" :options="hxpList" check-strictly :props="{ expandTrigger: 'hover' }" />
              </template>
            </el-table-column>
            <el-table-column label="包装层级">
              <template slot-scope="scope">
                <el-select size="mini" v-model="addForm.hxpList[scope.$index].bzcjBm" placeholder="请选择">
                  <el-option v-for="item in bzList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="RFID厂家">
              <template slot-scope="scope">
                <el-select size="mini" v-model="addForm.hxpList[scope.$index].bqcsBm" placeholder="请选择">
                  <el-option v-for="item in RFIDList" :key="item.bm" :label="item.mc" :value="item.bm" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="申请数量(最大100)">
              <template slot-scope="scope">
                <el-input-number size="mini" v-model="addForm.hxpList[scope.$index].sqsl" controls-position="right"
                  :min="1" :step="1" :precision="0" :max="100"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                <el-button style="color: #f00;" size="mini" type="text" @click="addForm.hxpList.splice(scope.$index, 1)"
                  v-if="addForm.hxpList.length > 1">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <div class="addBtn" @click="$emit('addHxp')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div style="text-align: center; margin-top: 50px">
            <el-button type="primary" @click="$emit('onSubmit')" style="background-color: rgb(65, 112, 255);
    color: white;
    width: 148px;
    height: 60px;
    border: none;">提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  exportByIds
} from '@/assets/js/zsmgl'

export default {
  name: 'zsmglDetail',
  props: {
    digshow: {
      type: Boolean,
      default: false
    },
    isDetails: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    },
    dataobj: {
      type: Array,
      default: () => []
    },
    addForm: {
      type: Object,
      default: () => ({
        hxpList: []
      })
    },
    hxpList: {
      type: Array,
      default: () => []
    },
    bzList: {
      type: Array,
      default: () => ([{ label: '上层包装', value: 0 }, { label: '最小包装', value: 1 }])
    },
    RFIDList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedRows: [],
      rules: {
        dwmc: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        shtyxydm: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        lxrXm: [
          { required: true, message: '请输入单位联系人', trigger: 'blur' }
        ],
        lxrSjh: [
          { required: true, message: '请输入联系人手机号码', trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    handleSingleDownload(row) {
      const data = [row.id]

      exportByIds(data).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `追溯码_${row.hxpMc}_${row.bzcjMc}.xlsx`
        a.click()
        URL.revokeObjectURL(url)
      }).catch(err => {
        console.error('下载失败:', err)
        this.$message.error('下载失败')
      })
    },
    handleBatchDownload() {
      if (this.selectedRows.length === 0) {
        this.$message.warn('请选择要下载的项目')
        return
      }

      const data = this.selectedRows.map(row => row.id)

      exportByIds(data).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `批量追溯码_${new Date().getTime()}.xlsx`
        a.click()
        URL.revokeObjectURL(url)
      }).catch(err => {
        console.error('批量下载失败:', err)
        this.$message.error('批量下载失败')
      })
    }
  }
}
</script>

<style scoped lang="less">
.addBtn {
  display: inline-block;
  position: relative;
  width: 150px;
  height: 0;
  border-top: 30px solid #F2F2F2;
  /* 顶部边框作为梯形高度 */
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  cursor: pointer;

  i {
    position: absolute;
    top: -22px;
    left: 50% - 8px;
    color: #000;
    font-weight: bold;
  }
}

.t_xkz,
.t_rk {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  padding-bottom: 20px;

  .bottom_title {
    .title {
      &::before {
        background: #D03CE9;
      }
    }
  }

  .title {
    position: relative;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;

    &::before {
      content: '';
      width: 4px;
      height: 18px;
      background-color: #4170ff;
      position: absolute;
      left: -20px;
      top: 5px;
    }
  }
}

.t_dig {
  .t_xkz {
    padding: 30px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;

    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .t_rk {
    padding: 30px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;

    .title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      padding-bottom: 10px;
      // border-bottom: 1px solid #ebeef5;
    }

    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .bottom_container {
    .bottom_title {
      padding: 30px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;

      .title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebeef5;
      }

      .main_lc {
        margin-top: 20px;
      }
    }
  }
}
</style>
